import React from 'react';
import { CallInboundView } from './call-inbound-view';
import useScreenPop from '../../hooks/use-screen-pop/use-screen-pop';

export const CallScreenPop: React.FC<{ phoneNumber: string }> = ({ phoneNumber }) => {
    const { ignoreCall, kazooCalls } = useScreenPop();
    const call = kazooCalls.find(c => c.phoneNumber === phoneNumber);
    return call?.isReady && !call?.isIgnored && !call?.hasCallPopup
        ? <CallInboundView phoneNumber={phoneNumber} onIgnore={() => ignoreCall(phoneNumber)} /> 
        : null;
}
